<footer>
    <a href="{{ 'FOOTER.WANASCHOOL-LINK' | translate }}">{{ 'FOOTER.WANASCHOOL' | translate }}</a>
    <a href="{{ 'FOOTER.BRAND-LINK' | translate }}">{{ 'FOOTER.BRAND' | translate }}</a>
</footer>
